import {Component} from '@angular/core';
import {faLinkedin, faXTwitter, faYoutube} from '@fortawesome/free-brands-svg-icons';
import {FaIconComponent} from "@fortawesome/angular-fontawesome";


@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    imports: [
    FaIconComponent
],
    styleUrls: ['./footer.component.css']
})
export class FooterComponent {
  faYoutube = faYoutube;
  faXTwitter = faXTwitter;
  faLinkedin = faLinkedin;
}
